import React, { useEffect, useState } from 'react';
import { FaTimes, FaSpinner } from 'react-icons/fa';
import api from '../../../services/api';

const EmailPreviewModal = ({ isOpen, onClose, reportId }) => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && reportId) {
      fetchPreview();
    } else {
      setPreviewData(null);
      setError(null);
    }
    // eslint-disable-next-line
  }, [isOpen, reportId]);

  const fetchPreview = async () => {
    setLoading(true);
    setError(null);
    setPreviewData(null);
    try {
      const response = await api.emailReports.preview(reportId);
      setPreviewData(response.data);
    } catch (err) {
      setError('Failed to load preview: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-surface rounded-lg shadow-lg w-full max-w-4xl p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
        >
          <FaTimes size={20} />
        </button>
        <h2 className="text-xl font-bold mb-4">Email Report Preview</h2>
        {loading ? (
          <div className="flex flex-col items-center justify-center py-8">
            <FaSpinner className="animate-spin text-2xl mb-2" />
            <span>Loading preview...</span>
          </div>
        ) : error ? (
          <div className="text-red-600 py-4">{error}</div>
        ) : previewData ? (
          <div className="border border-gray-200 rounded bg-gray-50 max-h-[60vh] overflow-auto">
            {previewData.subject && (
              <div className="px-4 py-2 bg-gray-100 border-b border-gray-200">
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Subject
                </span>
                <p className="text-sm font-medium text-gray-900 mt-0.5">{previewData.subject}</p>
              </div>
            )}
            <div className="p-4">
              {previewData.html ? (
                <div dangerouslySetInnerHTML={{ __html: previewData.html }} />
              ) : (
                <pre className="whitespace-pre-wrap">{JSON.stringify(previewData, null, 2)}</pre>
              )}
            </div>
          </div>
        ) : (
          <div className="text-gray-500 py-4">No preview data available.</div>
        )}
        <div className="flex justify-end mt-6">
          <button
            className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailPreviewModal;
